import React from "react";

import { ANNOTATION_COLORS, ANNOTATION_OPACITY } from "@perceptron/constants/colors";
import { Point, AnnotationSource } from "@perceptron/core/types";
import { normalizedToPercentage } from "@perceptron/utils/math";

import { useAnnotationInteractions } from "@demo/hooks/annotations/useAnnotationInteractions";

import { BasePointAnnotation } from "./BasePointAnnotation";

interface PointAnnotationMarkerProps {
  pointMarker: {
    id: string;
    label: string;
    coordinates: Point;
    source: AnnotationSource;
  };
}

export const PointAnnotationMarker = React.memo(function PointAnnotationMarker({
  pointMarker,
}: PointAnnotationMarkerProps) {
  const { isHighlighted, isDimmed, isCollectionHighlighted } = useAnnotationInteractions();

  const getMarkerStyle = () => {
    const baseStyle = {
      backgroundColor: ANNOTATION_COLORS.PRIMARY,
      borderColor: ANNOTATION_COLORS.PRIMARY,
    };

    if (isHighlighted(pointMarker.id) || isCollectionHighlighted([pointMarker.id])) {
      return {
        ...baseStyle,
        boxShadow: `0 0 12px rgba(${ANNOTATION_COLORS.PRIMARY_RGB}, ${ANNOTATION_OPACITY.GLOW})`,
        transform: "translate(-50%, -50%) scale(1.5)",
      };
    }
    if (isDimmed(pointMarker.id)) {
      return {
        backgroundColor: `rgba(${ANNOTATION_COLORS.PRIMARY_RGB}, ${ANNOTATION_OPACITY.STROKE_DIMMED})`,
        borderColor: `rgba(${ANNOTATION_COLORS.PRIMARY_RGB}, ${ANNOTATION_OPACITY.GLOW})`,
        transform: "translate(-50%, -50%)",
      };
    }
    return {
      ...baseStyle,
      transform: "translate(-50%, -50%)",
    };
  };

  return (
    <BasePointAnnotation
      className="absolute h-3 w-3 rounded-full border-2"
      id={pointMarker.id}
      labelText={pointMarker.label}
      source={pointMarker.source}
      style={{
        left: `${normalizedToPercentage(pointMarker.coordinates.x)}%`,
        top: `${normalizedToPercentage(pointMarker.coordinates.y)}%`,
        ...getMarkerStyle(),
      }}
    >
      <></>
    </BasePointAnnotation>
  );
});
